import {faDownload} from '@fortawesome/pro-regular-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Text} from '@rdcomponents/text/text';
import {Button, Flex, Form} from 'antd';
import {useState} from 'react';

import {spacer_xs} from '../../../../../css/var-export.scss';
import {Locale} from '../../../../../provider/locale/localization';
import {useSnackbar} from '../../../../../provider/snackbar/snackbar-hook';
import {useFormRules} from '../../../../../service/form/form-rules-hook';
import {
    CUSTOM_REVIEWS_IMPORT_TEMPLATE_FILENAME,
    fetchCustomReviewsImportTemplate,
} from '../../../../../service/reviews/reviews-custom-reviews-import-helper';
import {downloadBlob} from '../../../../../util/fetch';

import {ImportReviewsFileDragger} from './import-reviews-file-dragger';
import {normalizeImportReviewsUploadFileList} from './import-reviews-form-helper';
import {ImportReviewsFormFieldNamesEnum, ImportReviewsFormFieldsType} from './import-reviews-form-type';
import * as styles from './import-reviews-file-upload.module.scss';

export function ImportReviewsFileUpload(): JSX.Element {
    const {requiredFieldRule} = useFormRules();
    const {snackbar} = useSnackbar();
    const [isTemplateDownloading, setIsTemplateDownloading] = useState(false);

    async function handleDownloadTemplate() {
        setIsTemplateDownloading(true);

        try {
            const templateBlob = await fetchCustomReviewsImportTemplate();

            if (templateBlob) {
                downloadBlob(templateBlob, CUSTOM_REVIEWS_IMPORT_TEMPLATE_FILENAME);
            }
        } catch {
            snackbar.error({
                message: <Locale stringKey="ERROR__SOMETHING_WENT_WRONG" />,
                description: <Locale stringKey="SNACKBAR__ERROR__TECH_SUPPORT" />,
            });
        } finally {
            setIsTemplateDownloading(false);
        }
    }

    return (
        <div className={styles.ImportReviewsFileUpload_formItemRoot}>
            <div className={styles.ImportReviewsFileUpload_labelRow}>
                <Flex align="center" gap={spacer_xs}>
                    <Text large lighter stringKey="REVIEW_IMPORT__FILE_UPLOAD_LABEL" />
                    <span className={styles.ImportReviewsFileUpload_requiredMark}>*</span>
                </Flex>

                <Button
                    icon={<FontAwesomeIcon icon={faDownload} />}
                    loading={isTemplateDownloading}
                    onClick={handleDownloadTemplate}
                    size="small"
                >
                    <Locale stringKey="REVIEW_IMPORT__DOWNLOAD_TEMPLATE" />
                </Button>
            </div>

            <Form.Item<ImportReviewsFormFieldsType>
                className={styles.ImportReviewsFileUpload_fileFormItem}
                getValueFromEvent={normalizeImportReviewsUploadFileList}
                name={ImportReviewsFormFieldNamesEnum.reviewsFile}
                rules={[requiredFieldRule]}
                valuePropName="fileList"
            >
                <ImportReviewsFileDragger />
            </Form.Item>
        </div>
    );
}
